import React, {Component} from 'react';
import { Row, Col, Button, Accordion, Card, FormControl, Form } from 'react-bootstrap'
import api from '../../api'
import axios from 'axios'

export default class OpenQueries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            queries:[],
            isLoading:false
        }
        this.respondInput = React.createRef()
        this.onChangeResponse = this.onChangeResponse.bind(this);
    }

    componentDidMount = async () => {
        this.setState({ isLoading: true })
        let payload = {recipient:'101200771964745',resolved:false}
        await api.postService('chat/get/custom',payload).then(queries => {
            console.log("queries:",queries)
            this.setState({
                queries: queries.data.data,
                isLoading: false,
            })
        })
    }

    onChangeResponse(e){
        const id = parseInt(e.target.id)
        const response_text = e.target.value.toString()
        this.state.queries[id].reply = response_text
    }

    handleResponse = async (id) => {
        this.setState({ isLoading: true })

        const fb_api = "https://graph.facebook.com/v6.0/me/messages?access_token=EAAkanQFH5mQBAGC1ltDXQbWybh9INAgdB0obMtFZCscOUsVaXWw4OJCZCFKOQzPw33GuZCM0yLBFaYzMIOZBOINOUMMpd9GUWExGXlkdL3uXGJBcEfDLJdM80iZC62MZAPKGeaOrftCSyxV1i16FyBQYYjrwB8qE6y6U4OIweyNwZDZD"
        axios.post(fb_api, 
            {
                "messaging_type": "RESPONSE",
                "recipient": {
                    "id": this.state.queries[id].fb_recipient_id
                },
                "message": {
                    "text": this.state.queries[id].reply
                }
            }
        )

        await api.updateQueryById(
            this.state.queries[id]._id,
            {
                "reply": this.state.queries[id].reply
            }
        ).then(res => {
            this.setState({isLoading:true})
        })

    }


    render() {
        const queries = this.state.queries
        return (
            <div className="gs-container">
                <Accordion defaultActiveKey="0">
                    {queries.map((item,index) =>
                        <Card>
                            <Accordion.Toggle as={Card.Header} variant="link" eventKey={index}>
                                Q{index}: {item.query.substr(0,40)}... 
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={index}>
                                <Card.Body>
                                When: {item.query_time}<br/>
                                From: {item.from}<br/>
                                <br/>
                                {item.query}
                                <br/><br/>
                                    <Row className="p-2">
                                        <Col sm="auto">
                                            <Button
                                                // className={"navbar-button"}
                                                size='sm'
                                                variant="primary"
                                                onClick={ () => this.handleResponse(index)}
                                            >
                                                Respond
                                            </Button>
                                        </Col>
                                        <Col>

                                            <FormControl 
                                                        id = { index.toString()}
                                                        placeholder ={item.reply}
                                                        as="textarea" aria-label="Respond" 
                                                        onChange={this.onChangeResponse}
                                            />
                                        </Col>
                                    </Row>
                                    {item.reply_time === undefined? "": "Responded at " + item.reply_time}
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    
                    )}
                </Accordion>
            </div>
        )
    }
}